export enum FieldFormat {
  LIST = 'LIST',
  BOOLEAN = 'BOOLEAN',
  TEXT = 'TEXT',
  DATE = 'DATE',
  FULLTEXT = 'FULLTEXT',
  NUMBER = 'NUMBER',
}

/** Entspricht dem Backend-DTO `FieldTypeResponseDto`. */
export interface FieldTypeResponseDto {
  format: FieldFormat;
  name: string;
  size: number;
  editable: boolean;
  operators: string[];
  values?: string[];
}
